document.addEventListener("DOMContentLoaded", () => {
  // Update price of product card when variant is changed
  document.querySelectorAll(".product-card").forEach((productCard) => {
    productCard
      .querySelector(".product-card__variant-selector")
      ?.addEventListener("change", (e) => {
        // Update button with variant price
        const variantPrice =
          e.target.options[e.target.selectedIndex].dataset.price;
        if (variantPrice) {
          productCard.querySelector(
            ".product-card__buy-button-price-span"
          ).innerHTML = variantPrice;
        }
        // Update button with variant compare at price
        const variantCompareAtPrice =
          e.target.options[e.target.selectedIndex].dataset.compare_at_price;
        if (variantCompareAtPrice) {
          productCard.querySelector(
            ".product-card__buy-button-compare-at-price-span"
          ).innerHTML = variantCompareAtPrice;
        }
      });
  });

  // js/common/product/product-gallery-savings-tag.js
  class ProductGallerySavingsTag extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.productRerender = document.querySelector("product-rerender");
      if (!this.productRerender) return;

      this.productRerender.addEventListener(
        "variant:change",
        this.onVariantChange
      );
    }

    onVariantChange = () => {
      const savings = this.productRerender.querySelector(
        ".price-list__savings"
      )?.textContent;
      this.textContent = savings ?? "";
    };

    disconnectedCallback() {
      this.productRerender?.removeEventListener(
        "variant:change",
        this.onVariantChange
      );
    }
  }

  customElements.define(
    "product-gallery-savings-tag",
    ProductGallerySavingsTag
  );
});
